/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Rate_LimitsInputs */

const en_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limits`)
};

const ar_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود المعدل`)
};

const bn_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেট লিমিট`)
};

const de_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifbegrenzungen`)
};

const es_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de tarifas`)
};

const fr_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de taux`)
};

const pt_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de taxa`)
};

const zh_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速率限制`)
};

const tr_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oran sınırları`)
};

const ru_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничения ставок`)
};

const pl_svchip_rate_limits = /** @type {(inputs: Svchip_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity stawek`)
};

/**
* | output |
* | --- |
* | "Rate limits" |
*
* @param {Svchip_Rate_LimitsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_rate_limits = /** @type {((inputs?: Svchip_Rate_LimitsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Rate_LimitsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_rate_limits(inputs)
	if (locale === "bn") return bn_svchip_rate_limits(inputs)
	if (locale === "de") return de_svchip_rate_limits(inputs)
	if (locale === "es") return es_svchip_rate_limits(inputs)
	if (locale === "fr") return fr_svchip_rate_limits(inputs)
	if (locale === "pt") return pt_svchip_rate_limits(inputs)
	if (locale === "zh") return zh_svchip_rate_limits(inputs)
	if (locale === "tr") return tr_svchip_rate_limits(inputs)
	if (locale === "ru") return ru_svchip_rate_limits(inputs)
	if (locale === "pl") return pl_svchip_rate_limits(inputs)
	return en_svchip_rate_limits(inputs)
});